import React from 'react'
import DashboardHeader from '../../components/Shop/Layout/DashboardHeader'
import DashboardSideBar from '../../components/Shop/Layout/DashboardSideBar'
import AllOrders from "../../components/Shop/AllOrders";

const ShopAllOrders = () => {
  return (
    <div className="dashboard-page-wrapper">
      <DashboardHeader />
      <div className="dashboard-flex-wrapper">
        <div className="w-[80px] 800px:w-[330px] dashboard-sidebar">
          <DashboardSideBar active={2} />
        </div>
        <div className="dashboard-main-content flex-1">
          <AllOrders />
        </div>
      </div>
    </div>
  )
}

export default ShopAllOrders